function isInvalidToken(error) {
  return error && error.error && error.error.code === 102;
}

export default {
  isInvalidToken,
};
